import React from 'react';
import cn from 'classnames';
import Icon from '../icon';
import { random } from '../../../utils/utils';
import { bbCodeToHtml } from '../../../utils/formUtils';
import { Visibility } from '../../../types/common-types';
import './style.scss';

export interface RadioItemProps {
  label?: string;
  value: string;
  onClick: (value: string) => void;
  visibility?: Visibility;
  activeItem?: string;
  className?: string;
  styleName?: string;
}

const RadioItem: React.FC<RadioItemProps> = ({
  label,
  onClick,
  value,
  visibility = Visibility.Visible,
  activeItem,
  className,
}) => {
  const uniqId = random();
  const uId = `id-${uniqId}`;
  const isChecked = activeItem === value;

  const handleOnClick = () => {
    if (visibility === Visibility.Visible) {
      onClick(value);
    }
  };
  return (
    <div
      className={className}
      data-cy="radioItem"
      data-cy-value={value}
      styleName={cn('item', {
        disabled: visibility === Visibility.Disabled,
        hidden: visibility === Visibility.Hidden,
        checked: isChecked,
      })}
    >
      <div styleName="item__content">
        <div styleName="item__box">
          <input
            id={uId}
            value={value ? value.toString() : ''}
            type="radio"
            onClick={handleOnClick}
          />
          <Icon
            styleName="item__icon"
            value={isChecked ? 'radio_on' : 'radio_off'}
          />
        </div>
        <label styleName="item__label" htmlFor={uId}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: bbCodeToHtml(label),
            }}
          />
        </label>
      </div>
    </div>
  );
};
export default RadioItem;
